module.exports = __webpack_public_path__ + "static/media/context_blurred.2773c17c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Ideation/img/context_blurred.mp4
// module id = 146
// module chunks = 0